function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRulesIconsLiving = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 14.07 14.95",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.77,13.91c-.45,.29-1.03,.29-1.48,0C4.53,12.8,.22,9.78,.22,6.84,.22,4.35,2.02,2.66,4.24,2.66c.91,0,1.85,.46,2.48,1.13,.17,.18,.46,.18,.63,0,.62-.67,1.56-1.13,2.48-1.13,2.22,0,4.02,1.68,4.02,4.17,0,2.94-4.31,5.96-6.07,7.07Z",
    style: {
      fill: "#ee305c"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRulesIconsLiving, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RulesIcons_Living.24edce70.svg";
export { ForwardRef as ReactComponent };